import React, {forwardRef, useRef} from "react";
import ThemeData from "../../../Interfaces/ThemeData";
import ReactPlayer from "react-player";
import ThemesPopupItemPlayerContainer from "./ThemesPopupItemPlayerContainer";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setThemePopupVolume} from "../../../store/makerDataSlice";

interface ThemesPopupItemProps {
    theme: ThemeData,
    playing: boolean,
    onThemeSelect: (theme: ThemeData) => void
}

const ThemesPopupItem: React.FC<ThemesPopupItemProps> = forwardRef(({
                                                             theme,
                                                             playing,
                                                             onThemeSelect
                                                         }, ref) => {

    const themePlayerRef = useRef<ReactPlayer>(null);

    const makerData = useAppSelector(state => state.makerData);
    const dispatch = useAppDispatch()

    return (
        <div className={`themesPopupItem ${theme.isVertical ? 'vertical' : ''}`}>
            <ReactPlayer
                ref={themePlayerRef}
                url={theme.videoUrl}
                key={theme.videoUrl}
                // volume={1}
                muted={false}
                playing={playing}
                loop={true}
                width={'100%'}
                height={'100%'}
                controls={true}
                wrapper={ThemesPopupItemPlayerContainer}
                theme={theme}
                onThemeSelect={onThemeSelect}
                playsinline={true}
                config={playing ?
                    {
                        file: {
                            attributes: {
                                controlsList: `nodownload${makerData?.vkLaunchParams?.vk_platform == 'mobile_web' || makerData?.vkLaunchParams?.vk_platform == 'mobile_android' ? ' nofullscreen' : ''}`,
                            }
                        }
                    } : {
                    file: {
                        attributes: {
                            preload: 'none',
                            controlsList: `nodownload${makerData?.vkLaunchParams?.vk_platform == 'mobile_web' || makerData?.vkLaunchParams?.vk_platform == 'mobile_android' ? ' nofullscreen' : ''}`,
                        }
                    }
                }}
                onReady={() => {
                    try {
                        themePlayerRef?.current?.getInternalPlayer().addEventListener("volumechange", (event:any) => {
                            if (event?.target?.volume) {
                                dispatch(setThemePopupVolume(event?.target?.volume));
                            }
                        });
                        if (themePlayerRef?.current?.getInternalPlayer()) {
                            // @ts-ignore
                            themePlayerRef?.current?.getInternalPlayer()?.volume = makerData.themePopupVolume;
                        }
                        // themePlayerRef?.current?.getInternalPlayer().addEventListener("fullscreenchange", (event:any) => {
                        //     console.log(event);
                        // });
                    } catch (err) {
                        // forgive
                    }
                }}
            />
        </div>
    )
})

export default ThemesPopupItem;